import { Expose, Type } from "class-transformer";
import { ProductSearchHitDto } from "./product-search-hit.dto";

export class ProductSearchResultDto {
  @Expose()
  @Type(() => ProductSearchHitDto)
  hits: ProductSearchHitDto[] = [];
}
